import { useCallback, useEffect, useState } from "react";
import { CalendlyExpert } from "../../../utils/api-objects/CalendlyExpert";
import { getMedicaluserByRole } from "../../../utils/apis/medical-user-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { ExpertRole } from "../../../utils/Enums";

export const useGetPhysicians = () => {
    const { auth } = useAuth();
    const idToken = auth.idToken;

    const [physicians, setPhysicians] = useState<CalendlyExpert[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchPhysicians = useCallback(async () => {
        if (!idToken) return;
        setIsLoading(true);
        setError(null);

        try {
            const result: CalendlyExpert[] | null = await getMedicaluserByRole(idToken, ExpertRole.Physician);
            if (result !== null) {
                setPhysicians(result);
            }
        } catch (err: any) {
            console.error("Failed to fetch physicians:", err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [idToken]);

    useEffect(() => {
        fetchPhysicians();
    }, [fetchPhysicians]);

    return { physicians, isLoading, error, refetch: fetchPhysicians };
}